import { markRaw } from 'vue';
import SettingsUsersSection from '../components/SettingsUsersSection.vue';
import SettingsTermReasonsSection from '../components/SettingsTermReasonsSection.vue';
import SettingsLeadSourcesSection from '../components/SettingsLeadSourcesSection.vue';
import SettingsTerminalsSection from '../components/SettingsTerminalsSection.vue';
import SettingsCompaniesSection from '../components/SettingsCompaniesSection.vue';
import SettingsChangeHistorySection from '../components/sections/SettingsChangeHistorySection.vue';
import SettingsAccountSection from '../components/sections/SettingsAccountSection.vue';
import SettingsDataImportSection from '../components/sections/SettingsDataImportSection.vue';

/**
 * Workspace administration sections (Settings modal sidebar).
 * Account is available to every signed-in user.
 * Groups: Administration (day-to-day) vs Data Import (cutover ops).
 */
export const settingsSections = [
  {
    key: 'users',
    label: 'Users',
    icon: 'pi-users',
    subtitle: 'Drivers app accounts and role assignment',
    bootstrapTabKey: 'settings',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsUsersSection)
  },
  {
    key: 'termReasons',
    label: 'Termination Reasons',
    icon: 'pi-list',
    subtitle: 'Categorized termination reasons for inactive drivers',
    bootstrapTabKey: 'settings',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsTermReasonsSection)
  },
  {
    key: 'leadSources',
    label: 'Lead Sources',
    icon: 'pi-share-alt',
    subtitle: 'Recruiting sources for Potential leads',
    bootstrapTabKey: 'settings',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsLeadSourcesSection)
  },
  {
    key: 'terminals',
    label: 'Terminals',
    icon: 'pi-map-marker',
    subtitle: 'Work terminals for onboarding and active drivers',
    bootstrapTabKey: 'settings',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsTerminalsSection)
  },
  {
    key: 'companies',
    label: 'Company Assignments',
    icon: 'pi-building',
    subtitle: 'Standard companies by W-2 / W-9 classification',
    bootstrapTabKey: 'settings',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsCompaniesSection)
  },
  {
    key: 'history',
    label: 'History',
    icon: 'pi-history',
    subtitle: 'Field-level audit for leads, onboarding, and drivers',
    bootstrapTabKey: 'history',
    navGroup: 'administration',
    navGroupLabel: 'Administration',
    component: markRaw(SettingsChangeHistorySection)
  },
  {
    key: 'dataImport',
    label: 'Data Import',
    icon: 'pi-upload',
    subtitle: 'Spreadsheet cutover upload and promote',
    bootstrapTabKey: 'settings',
    adminOnly: true,
    navGroup: 'dataImport',
    navGroupLabel: 'Data Import',
    component: markRaw(SettingsDataImportSection)
  },
  {
    key: 'account',
    label: 'Account',
    icon: 'pi-user',
    subtitle: 'Your profile and access',
    availableToAll: true,
    navGroup: 'account',
    navGroupLabel: 'Account',
    component: markRaw(SettingsAccountSection)
  }
];

export const getSettingsSectionByKey = (key) =>
  settingsSections.find((section) => section.key === key) || null;
